// extracted by mini-css-extract-plugin
export default {"mobileIcon":"umdwphLMPzkyPnnOTyOU"};